module.exports = __webpack_public_path__ + "static/media/ambassador.a47485c5.png";